import clsx from "classnames";
import { Container } from "react-bootstrap";

export const Spacer = ({ className }) => {
  return (
    <div className={clsx(className)}>
      <Container className="mw-xxl"></Container>
    </div>
  );
};

export default Spacer;
